module.exports = __webpack_public_path__ + "static/img/product_images_33_h5_zh.da12987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_33_h5_zh.png
// module id = IE8P
// module chunks = 34